import { render } from "./InfoHud.vue?vue&type=template&id=6abd85c5&scoped=true"
import script from "./InfoHud.vue?vue&type=script&lang=js"
export * from "./InfoHud.vue?vue&type=script&lang=js"

import "./InfoHud.vue?vue&type=style&index=0&id=6abd85c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abd85c5"]])

export default __exports__